import type { AnalyticsEventProperties } from '@server/analytics-events';

import { ANALYTICS_EVENTS, trackClientEvent } from '@/_shared/lib/analytics';
import type { SSEMessage } from '@/_shared/types';

// Keys of suggestion sets already reported in this page load. A set re-renders on every transcript update,
// on a sidebar remount and on switching back to a chat — none of that is a new exposure. A reload or a
// reopened chat in a new tab does send again; `turnId` lets analysis count distinct sets.
const shownKeys = new Set<string>();

/** Sends `chatSuggestionShown` once per `key` for the lifetime of the page. */
export function trackSuggestionShownOnce(
  key: string,
  properties: AnalyticsEventProperties['chatSuggestionShown'],
): void {
  if (shownKeys.has(key)) return;
  shownKeys.add(key);
  trackClientEvent(ANALYTICS_EVENTS.chatSuggestionShown, properties);
}

/** Test-only: forget which sets were reported. */
export function resetSuggestionShownForTest(): void {
  shownKeys.clear();
}

/** The turn a transcript message belongs to: the nearest `turn_start` at or before `index`. */
export function turnIdAt(messages: SSEMessage[], index: number): string | undefined {
  for (let i = Math.min(index, messages.length - 1); i >= 0; i--) {
    const message = messages[i]!;
    if (message.type === 'turn_start') return message.turnId;
  }
  return undefined;
}
